import { render, staticRenderFns } from "./HistoryNotificationList.vue?vue&type=template&id=04abbbb0&"
import script from "./HistoryNotificationList.vue?vue&type=script&lang=js&"
export * from "./HistoryNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports